import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';

const LoginPage = ({ showNotification, onLogin }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email || !password) {
      showNotification && showNotification('Email and password are required', 'error');
      return;
    }
    try {
      setLoading(true);
      const res = await axios.post('https://outiloeuvresvolees.inouiagency.com/api/auth/login', { email, password });
      if (res.data && res.data.success && res.data.token) {
        onLogin && onLogin(res.data.token, res.data.user);
        showNotification && showNotification('Logged in successfully', 'success');
        const redirectTo = (location.state && location.state.from && location.state.from.pathname) || '/';
        navigate(redirectTo, { replace: true });
      } else {
        const msg = (res.data && res.data.error) || 'Login failed';
        showNotification && showNotification(msg, 'error');
      }
    } catch (err) {
      const apiMsg = err && err.response && err.response.data && err.response.data.error;
      if (apiMsg) {
        const level = (err.response && err.response.status === 403) ? 'warning' : 'error';
        showNotification && showNotification(apiMsg, level);
      } else {
        showNotification && showNotification('Login failed', 'error');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-md mx-auto bg-white rounded-xl shadow-sm border border-gray-200 p-6">
      <h1 className="text-2xl font-bold text-gray-900 mb-4">Login</h1>
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Email</label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
            placeholder="you@example.com"
            required
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Password</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
            placeholder="••••••••"
            required
          />
        </div>
        <button
          type="submit"
          disabled={loading}
          className={`w-full px-4 py-2 rounded-md text-white font-medium ${loading ? 'bg-blue-400' : 'bg-blue-600 hover:bg-blue-700'}`}
        >
          {loading ? 'Signing in...' : 'Sign In'}
        </button>
        <div className="text-sm text-right">
          <a href="/forgot-password" className="text-blue-600 hover:text-blue-700">Forgot password?</a>
        </div>
      </form>
    </div>
  );
};

export default LoginPage;


